/* tslint:disable */
/* eslint-disable */
/**
 * Api Documentation
 * Api Documentation
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    JsonEventPartyComp,
    JsonEventPartyCompFromJSON,
    JsonEventPartyCompFromJSONTyped,
    JsonEventPartyCompToJSON,
} from './JsonEventPartyComp';

/**
 * 
 * @export
 * @interface ApiResultOfJsonEventPartyComp
 */
export interface ApiResultOfJsonEventPartyComp {
    /**
     * 
     * @type {JsonEventPartyComp}
     * @memberof ApiResultOfJsonEventPartyComp
     */
    data?: JsonEventPartyComp;
    /**
     * 
     * @type {string}
     * @memberof ApiResultOfJsonEventPartyComp
     */
    message?: string;
    /**
     * 
     * @type {object}
     * @memberof ApiResultOfJsonEventPartyComp
     */
    messageValues?: object;
    /**
     * 
     * @type {string}
     * @memberof ApiResultOfJsonEventPartyComp
     */
    requestId?: string;
    /**
     * 
     * @type {string}
     * @memberof ApiResultOfJsonEventPartyComp
     */
    result?: ApiResultOfJsonEventPartyCompResultEnum;
}

/**
* @export
* @enum {string}
*/
export enum ApiResultOfJsonEventPartyCompResultEnum {
    Ok = 'OK',
    Error = 'ERROR'
}

export function ApiResultOfJsonEventPartyCompFromJSON(json: any): ApiResultOfJsonEventPartyComp {
    return ApiResultOfJsonEventPartyCompFromJSONTyped(json, false);
}

export function ApiResultOfJsonEventPartyCompFromJSONTyped(json: any, ignoreDiscriminator: boolean): ApiResultOfJsonEventPartyComp {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'data': !exists(json, 'data') ? undefined : JsonEventPartyCompFromJSON(json['data']),
        'message': !exists(json, 'message') ? undefined : json['message'],
        'messageValues': !exists(json, 'messageValues') ? undefined : json['messageValues'],
        'requestId': !exists(json, 'requestId') ? undefined : json['requestId'],
        'result': !exists(json, 'result') ? undefined : json['result'],
    };
}

export function ApiResultOfJsonEventPartyCompToJSON(value?: ApiResultOfJsonEventPartyComp | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'data': JsonEventPartyCompToJSON(value.data),
        'message': value.message,
        'messageValues': value.messageValues,
        'requestId': value.requestId,
        'result': value.result,
    };
}

